import React, { useState } from "react";
import { css } from "styled-components/macro";
import { Field, ErrorMessage } from "formik";
import { LoginInput } from "../../../UI/register";
function Input({ half, title, name, type, error }) {
  const [state, setState] = useState(false);
  return type !== "file" ? (
    <div
      css={css`
        flex: 0 0 ${half ? "50%" : "100%;"};
        max-width: ${half ? "50%" : "100%;"};
        padding: 0 5px;
        margin-bottom: 10px;
        position: relative;
      `}
    >
      <LoginInput
        as={Field}
        name={name}
        type={type}
        placeholder={title}
        css={css`
          transition: 0.2s;
          border-color: ${error ? "var(--failed)" : "var(--color1)"};
        `}
      ></LoginInput>
      {error ? (
        <i
          className="md md-help-outline"
          onClick={() => {
            setState(!state);
          }}
          css={css`
            position: absolute;
            left: 5px;
            width: 30px;
            top: 0;
            bottom: 0;
            line-height: 50px !important;
            font-size: 1.5rem !important;
            color: var(--failed);
          `}
        ></i>
      ) : null}
      {error && state ? (
        <p
          css={css`
            position: absolute;
            background: var(--failed);
            left: 5px;
            right: 5px;
            bottom: -20px;
            margin: 0;
            z-index: 100;
            border-radius: 10px;
            color: #fff;
            font-size: 0.9rem;
            line-height: 25px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          `}
        >
          {error}
        </p>
      ) : null}
    </div>
  ) : null;
}
export default Input;
